import { j as jsxRuntimeExports } from './../../../../../ext/react/jsx-runtime.js';
import { Base } from '../../../Internal/Base/Base.js';

const pathStrings = {
    24: [
        'M19.065.843C18.576.354 17.718 0 17.027 0H8.595c-.926 0-1.69.751-1.69 1.68v2.96H3.531A2.53 2.53 0 001 7.17v13.5a2.531 2.531 0 002.53 2.53h10.125a2.531 2.531 0 002.53-2.53v-2.11h4.218c.934 0 1.688-.755 1.688-1.688V5.062c0-.691-.355-1.548-.843-2.036L19.065.843zM14.498 18.56H8.593a1.69 1.69 0 01-1.688-1.68V6.327H3.531a.844.844 0 00-.844.844v13.498c0 .466.378.844.844.844h10.123a.844.844 0 00.844-.844V18.56zM8.595 1.687h6.747V6.75h3.374V5.062H17.03V1.687c.245.001.672.178.843.349l2.183 2.183c.172.172.349.599.349.844l-.001 11.81H8.594V1.686z',
    ],
};
const IconCopy = ({ size, className, ...rest }) => {
    const paths = pathStrings[size].map((d, i) => (jsxRuntimeExports.jsx("path", { d: d, fillRule: "evenodd" }, String(i))));
    return (jsxRuntimeExports.jsx(Base, { as: "svg", height: size, width: size, viewBox: `0 0 ${size} ${size}`, className: className, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", preserveAspectRatio: "xMidYMid meet", fill: "currentColor", ...rest, children: paths }));
};
IconCopy.displayName = 'IconCopy';

export { IconCopy };
//# sourceMappingURL=IconCopy.js.map
